var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeConnecter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.87 16.47c-0.624 0.624-0.624 1.638 0 2.262l13.267 13.267h-36.138c-0.883 0-1.6 0.717-1.6 1.6s0.717 1.6 1.6 1.6h36.138l-13.267 13.267c-0.624 0.624-0.624 1.638 0 2.262s1.638 0.624 2.262 0l16-16c0.314-0.314 0.467-0.723 0.467-1.133s-0.157-0.819-0.47-1.133l-16-16c-0.624-0.624-1.638-0.624-2.262 0l0.003 0.006z",
    fill: "#223654"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8 8v51.2c0 2.646-2.154 4.8-4.8 4.8h-6.4c-0.883 0-1.6-0.717-1.6-1.6s0.717-1.6 1.6-1.6h6.4c0.883 0 1.6-0.717 1.6-1.6v-51.2c0-0.883-0.717-1.6-1.6-1.6h-6.4c-0.883 0-1.6-0.717-1.6-1.6s0.717-1.6 1.6-1.6h6.4c2.646 0 4.8 2.154 4.8 4.8z",
    fill: "#223654"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeConnecter);
export default __webpack_public_path__ + "static/media/se-connecter.e8e6af881f707282ebc435a08f248ce6.svg";
export { ForwardRef as ReactComponent };